export const VIEW_FINANCEIRO_CASHFLOW = 'VIEW_FINANCEIRO_CASHFLOW';
export const VIEW_FINANCEIRO_CASHFLOW_SUCCESSFUL =
  'VIEW_FINANCEIRO_CASHFLOW_SUCCESSFUL';
